var _rect, _rect2, _rect3, _rect4, _rect5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRightLookup(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 69,
    height: 80,
    viewBox: "0 0 69 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 32,
    height: 4,
    rx: 2,
    fill: "#AFB8C1"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 8,
    width: 32,
    height: 4,
    rx: 2,
    fill: "#AFB8C1"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 16,
    width: 32,
    height: 4,
    rx: 2,
    fill: "#AFB8C1"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 24,
    width: 32,
    height: 32,
    rx: 4,
    fill: "#54AEFF"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 36.5,
    y: 24,
    width: 32,
    height: 56,
    rx: 4,
    fill: "#FF7B7B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightLookup);
export default __webpack_public_path__ + "static/media/right-lookup.373bb0f50e4f3f055a692a46e70f348f.svg";
export { ForwardRef as ReactComponent };